var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPledgeMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1286 10.2617H13.8833C13.5631 10.2617 13.2559 10.3889 13.0295 10.6154C12.803 10.8419 12.6758 11.149 12.6758 11.4693V18.7145C12.6758 19.0348 12.803 19.342 13.0295 19.5684C13.2559 19.7949 13.5631 19.9221 13.8833 19.9221H21.1286C21.4489 19.9221 21.756 19.7949 21.9825 19.5684C22.2089 19.342 22.3362 19.0348 22.3362 18.7145V11.4693C22.3362 11.149 22.2089 10.8419 21.9825 10.6154C21.756 10.3889 21.4489 10.2617 21.1286 10.2617ZM17.506 11.7712C17.9063 11.7712 18.2902 11.9302 18.5733 12.2133C18.8564 12.4963 19.0154 12.8803 19.0154 13.2806C19.0154 13.6809 18.8564 14.0648 18.5733 14.3479C18.2902 14.631 17.9063 14.79 17.506 14.79C17.1056 14.79 16.7217 14.631 16.4386 14.3479C16.1556 14.0648 15.9965 13.6809 15.9965 13.2806C15.9965 12.8803 16.1556 12.4963 16.4386 12.2133C16.7217 11.9302 17.1056 11.7712 17.506 11.7712ZM20.5248 18.1108H14.4871V17.9598C14.4871 16.8435 15.848 15.6957 17.506 15.6957C19.1639 15.6957 20.5248 16.8435 20.5248 17.9598V18.1108Z",
    fill: "#8EB111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4693 13.8848H10.2617V21.13C10.2617 21.796 10.8033 22.3376 11.4693 22.3376H18.7145V21.13H11.4693V13.8848Z",
    fill: "#8EB111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPledgeMobileLogo);
export default __webpack_public_path__ + "static/media/pledge_mobile_logo.8518adb7154a04610b4d024ff54de41e.svg";
export { ForwardRef as ReactComponent };